import ErrorFallback from 'Components/ErrorFallback'
import { ErrorBoundary } from 'react-error-boundary'
import { Route, Routes } from 'react-router-dom'
import { CampaignType } from './campaignSlice'
import {
  CampaignListPage,
  MultiCodeCampaignDetailPage,
  SingleCodeCampaignDetailPage
} from './Pages'

const CampaignRoot = () => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Routes>
        <Route index element={<CampaignListPage />} />
        <Route path={`${CampaignType.singleCode}/:id`} element={<SingleCodeCampaignDetailPage />} />
        <Route
          path={`${CampaignType.singleCode}/create/`}
          element={<SingleCodeCampaignDetailPage />}
        />
        <Route path={`${CampaignType.multiCode}/:id`} element={<MultiCodeCampaignDetailPage />} />
        <Route
          path={`${CampaignType.multiCode}/create/`}
          element={<MultiCodeCampaignDetailPage />}
        />
      </Routes>
    </ErrorBoundary>
  )
}
export default CampaignRoot
